<template>
  <FormsFieldsWrapper
    :name="name"
    :label="label"
    :description="description"
    :error="{ message: errorMessage }"
    :success="{
      valid: meta.valid,
      message: successMessage,
    }"
  >
    <AutoComplete
      :id="name"
      :name="name"
      :model-value="inputValue"
      :placeholder="placeholder"
      :disabled="disabled"
      fluid
      multiple
      :typeahead="typeahead"
      :class="{ 'p-invalid': errorMessage }"
      @change="handleChange($event.value)"
      @option-unselect="handleChange(inputValue.filter(item => item !== $event.value))"
      @blur="onBlur"
    />
  </FormsFieldsWrapper>
</template>

<script setup lang="ts">
import useFormField, { defaultProps } from './useFormField'

const props = defineProps({
  typeahead: { type: Boolean, default: true },
  ...defaultProps,
})

const { name, inputValue, errorMessage, handleBlur, handleChange, meta }
  = useFormField(props)

const onBlur = (event: Event) => {
  handleBlur(event)

  const value = (event.target as HTMLInputElement).value
  if (value.length > 0) {
    (inputValue.value as string[]).push(value)
    handleChange(inputValue.value)
    ;(event.target as HTMLInputElement).value = ''
  }
}
</script>
